import stringCaseUtil from '@/utils/stringCase'

export default {
    methods: {
        ...stringCaseUtil
    }
}